<template>
  <v-dialog v-model="open" max-width="700px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-card width="100%" class="rounded-0">
        <v-row justify="space-between" no-gutters>
          <v-col :cols="noActionIcon ? 12 : 11" v-bind="attrs" v-on="on" v-ripple>
            <v-row no-gutters :style="`background-color: ${addItemBackColor}; color: ${addItemTextColor}`">
              <v-col cols="10" class="py-4 pl-4">
                <slot />
                <p v-if="title" class="text-subtitle-2 my-0">{{ title }}</p>
                <p v-if="description" class="text-caption my-0">{{ description }}</p>
              </v-col>
              <v-col cols="2" class="py-4 pr-4">
                <p class="text-subtitle-2 my-0 align-end">{{ noActionIcon ? '' : priceFormatted }}</p>
              </v-col>
            </v-row>
          </v-col>

          <v-spacer />

          <v-col class="py-4 align-end mr-2" v-if="!noActionIcon">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                    v-for="(item, key) in menuOptions"
                    :key="key"
                    link
                    v-on:click="() => onClickAction(key)"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>

                <v-divider class="my-2"/>

                <v-list-item v-on:click="() => onClickAction('ADD_UP')" link>
                  <v-list-item-title>Adicionar um item acima</v-list-item-title>
                </v-list-item>
                <v-list-item v-on:click="() => onClickAction('ADD_DOWN')" link>
                  <v-list-item-title>Adicionar um item abaixo</v-list-item-title>
                </v-list-item>

                <v-divider class="my-2"/>

                <v-list-item v-on:click="() => onClickAction('DELETE')" link>
                  <v-list-item-title>Excluir item</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-card>
    </template>

    <v-card>
      <v-card-title>Item do menu</v-card-title>

      <v-card-text>
        <v-form
            ref="form"
            v-model="formValid"
            lazy-validation
        >
          <v-row no-gutters>
            <v-col cols="12" md="8" sm="8" xs="12" class="pr-sm-4">
              <v-text-field
                  label="Nome do item"
                  v-model="formData.title"
                  :rules="titleRules"
                  required
                  dense
                  outlined
                  :counter="140"
                  v-on:keypress="keyPress"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" sm="4" xs="12">
              <v-text-field
                  label="Preço do item (R$)"
                  v-model="formData.price"
                  required
                  dense
                  outlined
                  v-mask="currencyMask"
                  v-on:keypress="keyPress"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="12">
              <v-textarea
                  rows="3"
                  auto-grow
                  label="Descrição do item"
                  v-model="formData.description"
                  :counter="1000"
                  :rules="descriptionRules"
                  required
                  dense
                  outlined
                  v-on:keypress="keyPress"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="secondary"
            text
            @click="cancel"
        >
          Cancelar
        </v-btn>
        <v-btn
            :loading="loading"
            color="primary"
            text
            @click="callAction"
        >
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
const currencyMask = createNumberMask({
  prefix: '',
  allowDecimal: true,
  includeThousandsSeparator: false,
  allowNegative: false
})

export default {
  name: "LocationMenuItemModal",
  props: {
    title: String,
    description: String,
    price: String,
    priceFormatted: String,
    action: {
      type: Function,
      required: true
    },
    noActionIcon: Boolean,
    clearOnSubmit: Boolean,
    addItemBackColor: String,
    addItemTextColor: String
  },
  methods: {
    keyPress: function(e) {
      if (e.keyCode === 13) this.callAction()
    },
    onClickAction: function(value) {
      this.$emit('action', value)
    },
    cancel: function() {
      this.open = false
    },
    callAction: async function () {
      if (this.validate()) {
        this.loading = true
        await this.action(this.formData)

        if (this.clearOnSubmit) {
          this.formData = {
            title: '',
            description: '',
            price: ''
          }
        }
        this.open = false
        this.loading = false
      }
    },
    validate: function() {
      return this.$refs.form.validate()
    }
  },
  data: () => ({
    menuOptions: {
      'FIRST': 'Mover para o início',
      'UP': 'Mover para cima',
      'DOWN': 'Mover para baixo',
      'LAST': 'Mover para o fim'
    },
    open: false,
    loading: false,
    formValid: true,
    formData: {
      title: '',
      description: '',
      price: ''
    },
    descriptionRules: [
      v => (v && v.length <= 1000 || !v) || 'A descrição pode ter no máximo 1.000 caracteres'
    ],
    titleRules: [
      v => !!v || 'O nome do item é obrigatório',
      v => (v && v.length <= 140) || 'O nome do item pode ter no máximo 140 caracteres',
    ],
    currencyMask
  }),
  created() {
    this.formData = JSON.parse(JSON.stringify({
      title: this.title,
      description: this.description,
      price: this.price,
    }))
  }
}
</script>

<style scoped>
.align-end {
  text-align: end;
}
</style>